<div class="upload-card">
  <h2 class="h2-spaced">Upload aFRR bands to SCADA</h2>
  <p class="text-small text-muted mb-3">
    Allowed Formats: CSV (Comma-Separated Values) • Max size : {{ maxSizeMB }} MB
  </p>

  <p-fileUpload
    mode="advanced"
    [customUpload]="false"
    [auto]="false"
    [multiple]="true"
    [showUploadButton]="false"
    [showCancelButton]="false"
    chooseLabel="Add files"
    uploadLabel="Upload"
    cancelLabel="Cancel"
    (onSelect)="onSelect($event)"
    [maxFileSize]="maxSizeMB * 1024 * 1024"
    [accept]="'.csv'">
  </p-fileUpload>

  <p-card *ngIf="items().length">
    <div *ngIf="items().length" class="upload-list">
      <div class="upload-item" *ngFor="let it of items()">
        <div class="file-info">
          <div class="name">{{ it.file.name }}</div>
          <div class="meta">{{ (it.file.size / 1024 / 1024) | number:'1.1-3' }} MB</div>
        </div>

        <div class="status">
          <p-progressBar
            [value]="it.progress"
            [showValue]="false"
            styleClass="progress">
          </p-progressBar>

          <div class="badge" [ngClass]="it.status">
            {{ it.status }}
          </div>
        </div>

        <div class="actions">
          <button pButton type="button" class="p-button-text"
                  *ngIf="it.status === 'error'"
                  (click)="retryUpload(it.id)">
            <i pButtonIcon class="pi pi-refresh"></i>
            <span pButtonLabel>Retry</span>
          </button>

          <button pButton type="button" class="p-button-text"
                  *ngIf="!['uploading', 'done'].includes(it.status)"
                  (click)="removeItem(it.id)">
            <i pButtonIcon class="pi pi-trash"></i>
          </button>
        </div>

        <div class="error" *ngIf="it.errorMessage">
          {{ it.errorMessage }}
        </div>
      </div>
    </div>
  </p-card>

  <div style="display: flex; justify-content: center; margin-top: 1rem;" *ngIf="items().length">
    <button pButton type="button" class="p-button-primary" *ngIf="canUpload()" (click)="startUploadAll()">
      <i pButtonIcon class="pi pi-upload"></i>
      <span pButtonLabel>Start upload</span>
    </button>
    <button pButton type="button" class="p-button-secondary" style="margin-left: 1rem;" *ngIf="canClearAll()" (click)="clearAll()">
      <i pButtonIcon class="pi pi-trash"></i>
      <span pButtonLabel>Clear all</span>
    </button>
  </div>

  <p-toast></p-toast>
</div>
